import { Directive, inject, Input } from '@angular/core';
import { UrlUtilsService } from '@rd/core/services/url-utils/url-utils.service';
import {
  BannerImageComponent,
  BannerImageConfig,
  SupportedImageTypes,
} from './banner-image.component';

export interface BannerImageSrcConfig {
  desktop: string;
  mobile: string;
}

@Directive({
  selector: 'rd-banner-image[bannerSrc]',
  standalone: true,
})
export class BannerImageSrcDirective {
  private bannerImageComponent = inject(BannerImageComponent);
  private urlUtilsService = inject(UrlUtilsService);

  @Input() set bannerSrc(bannerSrc: BannerImageSrcConfig) {
    this.bannerImageComponent.bannerImageConfig =
      this.generateBannerImageConfig(bannerSrc);
  }

  private generateBannerImageConfig({ desktop, mobile }: BannerImageSrcConfig) {
    const desktopImagePathWithouExtension = this.urlUtilsService.imageUrl(
      `/images/${desktop}`,
    );
    const mobileImagePathWithouExtension = this.urlUtilsService.imageUrl(
      `/images/${mobile}`,
    );

    const supportedImageTypes: SupportedImageTypes[] = ['avif', 'webp', 'jpg'];

    return supportedImageTypes.reduce((config, type) => {
      config[type] = {
        desktop: `${desktopImagePathWithouExtension}.${type}`,
        mobile: `${mobileImagePathWithouExtension}.${type}`,
      };

      return config;
    }, {} as BannerImageConfig);
  }
}
